import { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { FoodGroup, FoodGroupPayload } from '../../types/catalog'
import { FormField, Input, Row } from '../../components/ui/FormField'
import { TranslationFields } from '../../components/ui/TranslationFields'
import { tokens } from '../../styles/tokens'

interface Props {
  initial?: FoodGroup | null
  onChange: (payload: FoodGroupPayload) => void
}

const ColorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const ColorPreview = styled.div<{ $color: string }>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${p => p.$color};
  border: 1px solid ${tokens.purple100};
  flex-shrink: 0;
`

const ColorInput = styled.input`
  width: 44px;
  height: 36px;
  padding: 2px;
  border: 1px solid ${tokens.purple100};
  border-radius: 8px;
  cursor: pointer;
  background: none;
`

export function FoodGroupForm({ initial, onChange }: Props) {
  const [code, setCode] = useState(initial?.code ?? '')
  const [color, setColor] = useState(initial?.color ?? '#9b6bb5')
  const [position, setPosition] = useState(initial?.position ?? 0)
  const active = initial?.active ?? true
  const [translations, setTranslations] = useState(
    initial?.translations ?? [
      { locale: 'en', name: '' },
      { locale: 'es', name: '' },
    ]
  )

  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    onChangeRef.current({ code, color, position, active, translations })
  }, [code, color, position, active, translations])

  return (
    <>
      <Row>
        <FormField label="Code" hint="e.g. VEG">
          <Input
            placeholder="VEG"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
          />
        </FormField>
        <FormField label="Position">
          <Input
            type="number"
            value={position}
            onChange={e => setPosition(Number(e.target.value))}
          />
        </FormField>
      </Row>

      <FormField label="Color">
        <ColorRow>
          <ColorInput type="color" value={color} onChange={e => setColor(e.target.value)} />
          <ColorPreview $color={color} />
          <Input value={color} onChange={e => setColor(e.target.value)} placeholder="#9b6bb5" />
        </ColorRow>
      </FormField>

      <TranslationFields translations={translations} onChange={setTranslations} />
    </>
  )
}
